import AOS from 'aos';
AOS.init({
    duration: 400,
    easing: 'ease-in-out',
    disable: window.innerWidth < 960
})

// https://michalsnik.github.io/aos/
// https://www.npmjs.com/package/aos/v/2.3.4